import { operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';
import { SOURCE_CATEGORIES } from '@/voc/constants/feedback';

const { VOC } = PRODUCT_AREAS || {};
const { CAPTURE } = SUB_PRODUCT_AREAS || {};

export default {
    name: 'VocItemsSourceAgg',
    productArea: VOC,
    subProductArea: CAPTURE,
    responseFormat: 'rows',
    build: ({ type = 'feedback' }) => {
        const pipeline = o.pipeline(
            o.sources.vocItems({ type, appId: 'expandAppIds("*")' }),
            o.select({
                sourceCategory: 'sourceCategory',
                source: 'source',
                sourceIdentifier: 'sourceIdentifier',
            }),
            o.evaluate(
                'sourceIdentifier',
                'if(source == "PollResponse" || source == "NPS" || source == "CUSTOMER_SATISFACTION" || source == "PRODUCT_MARKET_FIT" || source == "USER_EXPERIENCE_LITE", join(split(sourceIdentifier, "")[0:27], ""), sourceIdentifier)',
            ),
            o.evaluate(
                'sourceIdentifier',
                `if(sourceCategory == "Integrations" || (${Object.keys(SOURCE_CATEGORIES)
                    .filter((category) => category !== 'Integrations')
                    .map((category) => `sourceCategory != "${category}"`)
                    .join(' && ')}), "", sourceIdentifier)`,
            ),
            o.group(['sourceCategory', 'source', 'sourceIdentifier']),
            o.merge(
                ['sourceIdentifier'],
                o.mappings({ guideName: 'name' }),
                o.pipeline(
                    o.sources.guides({ appId: 'expandAppIds("*")' }),
                    o.select({
                        sourceIdentifier: 'id',
                        name: 'name',
                    }),
                ),
            ),
            o.evaluate('guideName', 'if((source == "PollResponse") && isNil(guideName), "(Unavailable Guide)", guideName)'),
            o.evaluate('guideName', 'if((source == "NPS") && isNil(guideName), "(Unavailable NPS)", guideName)'),
        );

        return pipeline;
    },
};
